import styles from './QuickActions.module.css';

function QuickActions({ onLogClean, onLogRelapse, onRefresh, isLoading }) {
  return (
    <div className={styles.quickActions}>
      <h3 className={styles.title}>Quick Actions</h3>
      <p className={styles.subtitle}>Track your day with one click</p>
      
      <div className={styles.buttons}>
        <button 
          className={`${styles.button} ${styles.cleanButton}`}
          onClick={onLogClean}
          disabled={isLoading}
        >
          <span className={styles.buttonIcon}>😎</span>
          <span className={styles.buttonText}>Log Clean </span>
        </button>
        
        <button 
          className={`${styles.button} ${styles.relapseButton}`}
          onClick={onLogRelapse}
          disabled={isLoading}
        >
          <span className={styles.buttonIcon}>💦</span>
          <span className={styles.buttonText}>Log Fap</span>
        </button>
        
        <button 
          className={`${styles.button} ${styles.refreshButton}`}
          onClick={onRefresh}
          disabled={isLoading}
        >
          <span className={styles.buttonIcon}>🔄</span>
          <span className={styles.buttonText}>Refresh Stats</span>
        </button>
      </div>
    </div>
  );
}

export default QuickActions;